const initialState: UseUserReducerStateType = {
  cacheKey: '',

  user: {
    id: '',
    email: '',
    phone: '',
    name: '',
    lastname: '',
    fullname: '',
    role: '',
    site: '',
    about: '',
    avatar: '',
    observation: '',
    companyFantasyName: '',
    type: '',
    table: '',
    language: '',
  },

  typeUser: '',
  interests: {},
};
export default initialState;
